import React from "react"
import { Icon, Message } from "semantic-ui-react"
import ProductModelBase from "theme/base/shop/ProductModel"

export default class ProductModelFiebiger extends ProductModelBase {
  constructor( data ) {
    super( data )
    let showDeliveryDate = false
    switch (this.extras.status) {
      case "2":
      case "3":
      case "4":
        showDeliveryDate = true
        break;
    }
    
    this.stock = Number( this.extras.Lagerbestand ) || 0
    
    // #2018 - Set availability to infinity if NEUHEIT
    if ( this.extras.new || this.categoryDict[ 23 ] ) {
      this.stock = Infinity
    }
    
    if ( this.extras.orderable_value === "0" ) {
      this.stock = 0
    }
    
    if ( this.extras.orderable_value === "" || this.extras.orderable_value === undefined ) {
      this.stock = Infinity
    }
    
    this.showDeliveryDate = !!this.extras.liefab && showDeliveryDate
    this.getNotice()
  }
  
  getNotice = ( size ) => {
    // check special conditions
    
    const refQuantity = this.quantities[ 0 ]
    
    const color = this.extras.color_new || "green"
    
    const stock = Number( this.extras.Lagerbestand ) || 0
    let notice = null
    
    if ( size === "tiny" ) {
      
      if ( color === "blue" ) {
        this._available = false
        return notice =
          <span className={"avail-none"}><Icon
            color="blue" name="truck"
            title={this.showDeliveryDate ? `${translate( "lieferbar ab" )} ${this.extras.liefab_new}` : translate( "nicht lieferbar" )}/>
        			</span>
      }
      
      if ( color === "yellow" ) {
        return notice =
          <span className={"avail-none"}><Icon color="yellow" name="truck" title={translate( `wenig lieferbar` )}/></span>
      }
      
      if ( color === "green" ) {
        return notice = <span className={"avail-danger"}><Icon color="green" name="truck" title={translate( `lieferbar` )}/></span>
      }
      
      this._available = true
      return notice = <span className={"black-70 ttu"}><Icon color="green" name="truck" title="lieferbar"/></span>
    }
    
    if ( stock < refQuantity.multi * 2 ) {
      this._available = false
      return notice = <div className={"avail-none"}>
        {!this.showDeliveryDate && <div className={"blue pb2"}>
          <Icon color="blue" name="truck" title={translate( `nicht lieferbar` )}/>
          <span>{translate( "Nicht lieferbar" )}</span>
        </div>}
        {this.showDeliveryDate && <Message color="blue"><Icon color="blue" name="truck" title={translate( `nicht lieferbar` )}/> {translate( "Lieferbar ab:" )}
          <span> {this.extras.liefab}</span>
        </Message>}
      </div>
    }
    
    if ( stock <= refQuantity.multi * 5 ) {
      return notice = <span className={"avail-none"}><Icon color="yellow" name="truck" title={translate( `wenig lieferbar` )}/> {translate( "wenig lieferbar" )}</span>
    }
    
    if ( stock > refQuantity.multi * 5 ) {
      return notice = <span className={"avail-danger"}><Icon color="green" name="truck" title={`lieferbar`}/> {translate( "lieferbar" )}</span>
    }
    
    this._available = true
    return notice = <span className={"black-70   ttu"}><Icon color="green" name="truck" title={translate( "lieferbar" )}/> {translate( "lieferbar" )}</span>
    
  }
}


// WEBPACK FOOTER //
// ./src/theme/fiebiger/shop/ProductModel.js